import { IAppState } from '@state/types';
import { ISnackbar } from '@state/openReducers/types'

export const getOpenMenu = (state: IAppState): boolean | undefined => state.openMenuState.openMenu;

export const getOpenTemplate = (state: IAppState): boolean | undefined => state.openNewTemplateState.openNewTemplate;

export const getReloadList = (state: IAppState): boolean | undefined => state.reloadListState.reloadList;

export const getShowsnackBar = (state: IAppState): ISnackbar| undefined  => state.showSnackBar.snackbar;

